import { useBeforeLeave, useLocation } from "@solidjs/router"
import { createEffect } from "solid-js"

const SCROLLS = new Map()

function getScrollElement() {
  return document.querySelector("[data-main-scroll]")
}

export function useScrollRestoration() {
  const location = useLocation()

  useBeforeLeave(e => {
    if (e.from?.pathname) {
      SCROLLS.set(e.from.pathname, getScrollElement()?.scrollTop ?? 0)
    }
  })

  createEffect(() => {
    const scroll = SCROLLS.get(location.pathname)
    if (scroll !== undefined) {
      requestAnimationFrame(() => {
        getScrollElement()?.scrollTo(0, scroll)
      })
    }
  })
}
